import { UpdateAutoPublishSettingRequest } from "src/models/settings.model";

import API_URL from "./apiConfig/api.config";
import apiCall from "./apiConfig/apiCall.config";

export async function getAutoPublishSetting() {
  return await apiCall.get(API_URL.SETTINGS.AUTO_PUBLISH_SETTING);
}

export async function updateAutoPublishSetting(
  data: UpdateAutoPublishSettingRequest
) {
  return await apiCall.patch(API_URL.SETTINGS.AUTO_PUBLISH_SETTING, data);
}
